const tokens = {};
const theme = {
    meta: {
        scope: 'all',
        appearances: {
            ghostLink: {
                default: false,
            },
        },
        variantGroups: {
            status: {
                secondary: {
                    default: false,
                },
                tertiary: {
                    default: false,
                },
                gray: {
                    default: false,
                },
                dark: {
                    default: false,
                },
                info: {
                    default: false,
                },
            },
            size: {
                xs: {
                    default: false,
                },
                sm: {
                    default: true,
                },
                md: {
                    default: false,
                },
                lg: {
                    default: false,
                },
                xl: {
                    default: false,
                },
            },
        },
        parameters: {
            backgroundColorDark: {
                type: 'string',
            },
            height: {
                type: 'number',
            },
        },
    },
    appearances: {
        filled: {
            mapping: {
                textFontFamily: 'text-font-family',
                borderColor: 'transparent',
                textColor: '$color-text-white',
                iconTintColor: '$color-text-white',
                borderWidth: 1,
                borderRadius: 4,
            },
            variantGroups: {
                status: {
                    primary: {
                        backgroundColor: '$color-brand2-500',
                        backgroundColorDark: '$color-brand2-500',
                        state: {
                            hover: {
                                backgroundColor: '$color-brand2-700',
                                backgroundColorDark: '$color-brand2-700',
                            },
                            active: {
                                backgroundColor: '$color-brand2-900',
                                backgroundColorDark: '$color-brand2-900',
                            },
                            focus: {
                                backgroundColor: '$color-brand2-900',
                                backgroundColorDark: '$color-brand2-900',
                            },
                            disabled: {
                                textColor: '$color-text-white',
                                backgroundColor: '$color-brand2-20',
                                backgroundColorDark: '$color-brand2-20',
                            },
                        },
                    },
                    secondary: {
                        backgroundColor: '$color-brand1-500',
                        backgroundColorDark: '$color-brand1-500',
                        state: {
                            hover: {
                                backgroundColor: '$color-brand1-700',
                                backgroundColorDark: '$color-brand1-700',
                            },
                            active: {
                                backgroundColor: '$color-brand1-900',
                                backgroundColorDark: '$color-brand1-900',
                            },
                            focus: {
                                backgroundColor: '$color-brand1-900',
                                backgroundColorDark: '$color-brand1-900',
                            },
                            disabled: {
                                textColor: '$color-text-white',
                                backgroundColor: '$color-brand1-20',
                                backgroundColorDark: '$color-brand1-20',
                            },
                        },
                    },
                    tertiary: {
                        backgroundColor: '$color-gray-50',
                        backgroundColorDark: '$color-gray-50',
                        textColor: '$color-text-primary',
                        iconTintColor: '$color-text-primary',
                        state: {
                            hover: {
                                backgroundColor: '$color-gray-100',
                                backgroundColorDark: '$color-gray-100',
                            },
                            active: {
                                backgroundColor: '$color-gray-300',
                                backgroundColorDark: '$color-gray-300',
                            },
                            focus: {
                                backgroundColor: '$color-gray-300',
                                backgroundColorDark: '$color-gray-300',
                            },
                            disabled: {
                                textColor: '$color-text-extra-subtle',
                                iconTintColor: '$color-text-extra-subtle',
                                backgroundColor: '$color-gray-50',
                                backgroundColorDark: '$color-gray-50',
                            },
                        },
                    },
                    success: {
                        backgroundColor: '$color-success-500',
                        backgroundColorDark: '$color-success-500',
                        state: {
                            hover: {
                                backgroundColor: '$color-success-700',
                                backgroundColorDark: '$color-success-700',
                            },
                            active: {
                                backgroundColor: '$color-success-900',
                                backgroundColorDark: '$color-success-900',
                            },
                            focus: {
                                backgroundColor: '$color-success-900',
                                backgroundColorDark: '$color-success-900',
                            },
                            disabled: {
                                backgroundColor: '$color-success-20',
                                backgroundColorDark: '$color-success-20',
                            },
                        },
                    },
                    info: {
                        backgroundColor: '$color-info-500',
                        backgroundColorDark: '$color-info-500',
                        state: {
                            hover: {
                                backgroundColor: '$color-info-700',
                                backgroundColorDark: '$color-info-700',
                            },
                            active: {
                                backgroundColor: '$color-info-900',
                                backgroundColorDark: '$color-info-900',
                            },
                            focus: {
                                backgroundColor: '$color-info-900',
                                backgroundColorDark: '$color-info-900',
                            },
                            disabled: {
                                backgroundColor: '$color-info-20',
                                backgroundColorDark: '$color-info-20',
                            },
                        },
                    },
                    warning: {
                        backgroundColor: '$color-warning-500',
                        backgroundColorDark: '$color-warning-500',
                        state: {
                            hover: {
                                backgroundColor: '$color-warning-700',
                                backgroundColorDark: '$color-warning-700',
                            },
                            active: {
                                backgroundColor: '$color-warning-900',
                                backgroundColorDark: '$color-warning-900',
                            },
                            focus: {
                                backgroundColor: '$color-warning-900',
                                backgroundColorDark: '$color-warning-900',
                            },
                            disabled: {
                                backgroundColor: '$color-warning-20',
                                backgroundColorDark: '$color-warning-20',
                            },
                        },
                    },
                    danger: {
                        backgroundColor: '$color-danger-500',
                        backgroundColorDark: '$color-danger-500',
                        state: {
                            hover: {
                                backgroundColor: '$color-danger-700',
                                backgroundColorDark: '$color-danger-700',
                            },
                            active: {
                                backgroundColor: '$color-danger-900',
                                backgroundColorDark: '$color-danger-900',
                            },
                            focus: {
                                backgroundColor: '$color-danger-900',
                                backgroundColorDark: '$color-danger-900',
                            },
                            disabled: {
                                backgroundColor: '$color-danger-20',
                                backgroundColorDark: '$color-danger-20',
                            },
                        },
                    },
                    gray: {
                        backgroundColor: '$color-gray-100',
                        backgroundColorDark: '$color-gray-100',
                        textColor: '$color-text-white',
                        iconTintColor: '$color-text-white',
                        state: {
                            hover: {
                                backgroundColor: '$color-gray-200',
                                backgroundColorDark: '$color-gray-200',
                            },
                            active: {
                                backgroundColor: '$color-gray-300',
                                backgroundColorDark: '$color-gray-300',
                            },
                            gray: {
                                backgroundColor: '$color-gray-300',
                                backgroundColorDark: '$color-gray-300',
                            },
                            disabled: {
                                backgroundColor: '$color-gray-80',
                                backgroundColorDark: '$color-gray-80',
                            },
                        },
                    },
                    dark: {
                        backgroundColor: '$color-gray-700',
                        backgroundColorDark: '$color-gray-700',
                        textColor: '$color-text-white',
                        iconTintColor: '$color-text-white',
                        state: {
                            hover: {
                                backgroundColor: '$color-gray-500',
                                backgroundColorDark: '$color-gray-500',
                            },
                            active: {
                                backgroundColor: '$color-gray-700',
                                backgroundColorDark: '$color-gray-700',
                            },
                            focus: {
                                backgroundColor: '$color-gray-700',
                                backgroundColorDark: '$color-gray-700',
                            },
                            disabled: {
                                backgroundColor: '$color-gray-20',
                                backgroundColorDark: '$color-gray-20',
                            },
                        },
                    },
                },
                size: {
                    text: {
                        textFontSize: 15,
                        paddingVertical: 0,
                        paddingHorizontal: 0,
                        iconMarginHorizontal: 0,
                        textMarginHorizontal: 0,
                    },
                    xs: {
                        minWidth: 'size-xs',
                        minHeight: 'size-xs',
                        borderWidth: 'border-width',
                        paddingHorizontal: 12,
                        paddingVertical: 4,
                        textMarginHorizontal: 6,
                        textFontSize: 14,
                        textFontWeight: 'bold',
                        iconWidth: 12,
                        iconHeight: 12,
                        iconMarginHorizontal: 0,
                    },
                    sm: {
                        minWidth: 'size-sm',
                        minHeight: 'size-sm',
                        borderWidth: 'border-width',
                        paddingHorizontal: 16,
                        paddingVertical: 6,
                        textMarginHorizontal: 8,
                        textFontSize: 15,
                        textFontWeight: 'bold',
                        iconWidth: 16,
                        iconHeight: 16,
                        iconMarginHorizontal: 0,
                    },
                    md: {
                        minWidth: 'size-md',
                        minHeight: 'size-md',
                        borderWidth: 'border-width',
                        paddingHorizontal: 20,
                        paddingVertical: 11,
                        textMarginHorizontal: 10,
                        textFontSize: 16,
                        textFontWeight: 'bold',
                        iconWidth: 20,
                        iconHeight: 20,
                        iconMarginHorizontal: 0,
                    },
                    lg: {
                        minWidth: 'size-lg',
                        minHeight: 'size-lg',
                        borderWidth: 'border-width',
                        paddingHorizontal: 24,
                        paddingVertical: 15,
                        textMarginHorizontal: 10,
                        textFontSize: 16,
                        textFontWeight: 'bold',
                        iconWidth: 24,
                        iconHeight: 24,
                        iconMarginHorizontal: 0,
                    },
                    xl: {
                        minWidth: 'size-xl',
                        minHeight: 'size-xl',
                        borderWidth: 'border-width',
                        paddingHorizontal: 28,
                        paddingVertical: 18,
                        textMarginHorizontal: 14,
                        textFontSize: 18,
                        textFontWeight: 'bold',
                        iconWidth: 28,
                        iconHeight: 28,
                        iconMarginHorizontal: 0,
                    },
                },
            },
        },
        outline: {
            mapping: {},
            variantGroups: {
                status: {
                    primary: {
                        borderColor: '$color-brand2-500',
                        textColor: '$color-brand2-500',
                        iconTintColor: '$color-brand2-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-brand2-500',
                                textColor: '$color-brand2-500',
                                iconTintColor: '$color-brand2-500',
                                backgroundColor: '$color-brand2-5',
                                backgroundColorDark: '$color-brand2-transparent-40',
                            },
                            active: {
                                borderColor: '$color-brand2-500',
                                textColor: '$color-brand2-500',
                                iconTintColor: '$color-brand2-500',
                                backgroundColor: '$color-brand2-20',
                                backgroundColorDark: '$color-brand2-transparent-56',
                            },
                            focus: {
                                borderColor: '$color-brand2-500',
                                textColor: '$color-brand2-500',
                                iconTintColor: '$color-brand2-500',
                                backgroundColor: '$color-brand2-20',
                                backgroundColorDark: '$color-brand2-transparent-56',
                            },
                            disabled: {
                                borderColor: '$color-brand2-20',
                                textColor: '$color-brand2-20',
                                iconTintColor: '$color-brand2-20',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    secondary: {
                        borderColor: '$color-brand1-500',
                        textColor: '$color-brand1-500',
                        iconTintColor: '$color-brand1-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-brand1-500',
                                textColor: '$color-brand1-500',
                                iconTintColor: '$color-brand1-500',
                                backgroundColor: '$color-brand1-5',
                                backgroundColorDark: '$color-brand1-transparent-40',
                            },
                            active: {
                                borderColor: '$color-brand1-500',
                                textColor: '$color-brand1-500',
                                iconTintColor: '$color-brand1-500',
                                backgroundColor: '$color-brand1-20',
                                backgroundColorDark: '$color-brand1-transparent-56',
                            },
                            focus: {
                                borderColor: '$color-brand1-500',
                                textColor: '$color-brand1-500',
                                iconTintColor: '$color-brand1-500',
                                backgroundColor: '$color-brand1-20',
                                backgroundColorDark: '$color-brand1-transparent-56',
                            },
                            disabled: {
                                borderColor: '$color-brand1-20',
                                textColor: '$color-brand1-20',
                                iconTintColor: '$color-brand1-20',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    tertiary: {
                        borderColor: '$color-gray-200',
                        textColor: '$color-text-primary',
                        iconTintColor: '$color-text-primary',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-gray-200',
                                textColor: '$color-text-primary',
                                iconTintColor: '$color-text-primary',
                                backgroundColor: '$color-gray-50',
                                backgroundColorDark: '$color-gray-transparent-40',
                            },
                            active: {
                                borderColor: '$color-gray-200',
                                textColor: '$color-text-primary',
                                iconTintColor: '$color-text-primary',
                                backgroundColor: '$color-gray-100',
                                backgroundColorDark: '$color-gray-transparent-56',
                            },
                            focus: {
                                borderColor: '$color-gray-200',
                                textColor: '$color-text-primary',
                                iconTintColor: '$color-text-primary',
                                backgroundColor: '$color-gray-100',
                                backgroundColorDark: '$color-gray-transparent-56',
                            },
                            disabled: {
                                borderColor: '$color-gray-100',
                                textColor: '$color-gray-100',
                                iconTintColor: '$color-gray-100',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    success: {
                        borderColor: '$color-success-500',
                        textColor: '$color-success-500',
                        iconTintColor: '$color-success-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-success-500',
                                textColor: '$color-success-500',
                                iconTintColor: '$color-success-500',
                                backgroundColor: '$color-success-5',
                                backgroundColorDark: '$color-success-transparent-40',
                            },
                            active: {
                                borderColor: '$color-success-500',
                                textColor: '$color-success-500',
                                iconTintColor: '$color-success-500',
                                backgroundColor: '$color-success-20',
                                backgroundColorDark: '$color-success-transparent-56',
                            },
                            focus: {
                                borderColor: '$color-success-500',
                                textColor: '$color-success-500',
                                iconTintColor: '$color-success-500',
                                backgroundColor: '$color-success-20',
                                backgroundColorDark: '$color-success-transparent-56',
                            },
                            disabled: {
                                borderColor: '$color-success-20',
                                textColor: '$color-success-20',
                                iconTintColor: '$color-success-20',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    info: {
                        borderColor: '$color-info-500',
                        textColor: '$color-info-500',
                        iconTintColor: '$color-info-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-info-500',
                                textColor: '$color-info-500',
                                iconTintColor: '$color-info-500',
                                backgroundColor: '$color-info-5',
                                backgroundColorDark: '$color-info-transparent-40',
                            },
                            active: {
                                borderColor: '$color-info-500',
                                textColor: '$color-info-500',
                                iconTintColor: '$color-info-500',
                                backgroundColor: '$color-info-20',
                                backgroundColorDark: '$color-info-transparent-56',
                            },
                            focus: {
                                borderColor: '$color-info-500',
                                textColor: '$color-info-500',
                                iconTintColor: '$color-info-500',
                                backgroundColor: '$color-info-20',
                                backgroundColorDark: '$color-info-transparent-56',
                            },
                            disabled: {
                                borderColor: '$color-info-20',
                                textColor: '$color-info-20',
                                iconTintColor: '$color-info-20',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    warning: {
                        borderColor: '$color-warning-500',
                        textColor: '$color-warning-500',
                        iconTintColor: '$color-warning-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-warning-500',
                                textColor: '$color-warning-500',
                                iconTintColor: '$color-warning-500',
                                backgroundColor: '$color-warning-5',
                                backgroundColorDark: '$color-warning-transparent-40',
                            },
                            active: {
                                borderColor: '$color-warning-500',
                                textColor: '$color-warning-500',
                                iconTintColor: '$color-warning-500',
                                backgroundColor: '$color-warning-20',
                                backgroundColorDark: '$color-warning-transparent-56',
                            },
                            focus: {
                                borderColor: '$color-warning-500',
                                textColor: '$color-warning-500',
                                iconTintColor: '$color-warning-500',
                                backgroundColor: '$color-warning-20',
                                backgroundColorDark: '$color-warning-transparent-56',
                            },
                            disabled: {
                                borderColor: '$color-warning-20',
                                textColor: '$color-warning-20',
                                iconTintColor: '$color-warning-20',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    danger: {
                        borderColor: '$color-danger-500',
                        textColor: '$color-danger-500',
                        iconTintColor: '$color-danger-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-danger-500',
                                textColor: '$color-danger-500',
                                iconTintColor: '$color-danger-500',
                                backgroundColor: '$color-danger-5',
                                backgroundColorDark: '$color-danger-transparent-40',
                            },
                            active: {
                                borderColor: '$color-danger-500',
                                textColor: '$color-danger-500',
                                iconTintColor: '$color-danger-500',
                                backgroundColor: '$color-danger-20',
                                backgroundColorDark: '$color-danger-transparent-56',
                            },
                            focus: {
                                borderColor: '$color-danger-500',
                                textColor: '$color-danger-500',
                                iconTintColor: '$color-danger-500',
                                backgroundColor: '$color-danger-20',
                                backgroundColorDark: '$color-danger-transparent-56',
                            },
                            disabled: {
                                borderColor: '$color-danger-20',
                                textColor: '$color-danger-20',
                                iconTintColor: '$color-danger-20',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    gray: {
                        borderColor: '$color-gray-200',
                        textColor: '$color-gray-200',
                        iconTintColor: '$color-gray-200',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-gray-200',
                                textColor: '$color-gray-200',
                                iconTintColor: '$color-gray-200',
                                backgroundColor: '$color-gray-10',
                                backgroundColorDark: '$color-gray-transparent-40',
                            },
                            active: {
                                borderColor: '$color-gray-200',
                                textColor: '$color-gray-200',
                                iconTintColor: '$color-gray-200',
                                backgroundColor: '$color-gray-80',
                                backgroundColorDark: '$color-gray-transparent-56',
                            },
                            focus: {
                                borderColor: '$color-gray-200',
                                textColor: '$color-gray-200',
                                iconTintColor: '$color-gray-200',
                                backgroundColor: '$color-gray-80',
                                backgroundColorDark: '$color-gray-transparent-56',
                            },
                            disabled: {
                                borderColor: '$color-gray-80',
                                textColor: '$color-gray-80',
                                iconTintColor: '$color-gray-80',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    dark: {
                        borderColor: '$color-gray-500',
                        textColor: '$color-text-white',
                        iconTintColor: '$color-text-white',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-gray-500',
                                textColor: '$color-text-white',
                                iconTintColor: '$color-text-white',
                                backgroundColor: '$color-gray-500',
                                backgroundColorDark: '$color-gray-transparent-40',
                            },
                            active: {
                                borderColor: '$color-brand2-500',
                                textColor: '$color-text-white',
                                iconTintColor: '$color-text-white',
                                backgroundColor: '$color-brand2-500',
                                backgroundColorDark: '$color-gray-transparent-56',
                            },
                            focus: {
                                borderColor: '$color-brand2-500',
                                textColor: '$color-text-white',
                                iconTintColor: '$color-text-white',
                                backgroundColor: '$color-brand2-500',
                                backgroundColorDark: '$color-gray-transparent-56',
                            },
                            disabled: {
                                borderColor: '$color-gray-500',
                                textColor: '$color-gray-500',
                                iconTintColor: '$color-gray-500',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                },
            },
        },
        ghost: {
            mapping: {},
            variantGroups: {
                status: {
                    primary: {
                        textColor: '$color-brand2-500',
                        iconTintColor: '$color-brand2-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-brand2-500',
                                iconTintColor: '$color-brand2-500',
                                backgroundColor: '$color-brand2-5',
                                backgroundColorDark: '$color-brand2-transparent-40',
                            },
                            active: {
                                textColor: '$color-brand2-500',
                                iconTintColor: '$color-brand2-500',
                                backgroundColor: '$color-brand2-20',
                                backgroundColorDark: '$color-brand2-transparent-56',
                            },
                            focus: {
                                textColor: '$color-brand2-500',
                                iconTintColor: '$color-brand2-500',
                                backgroundColor: '$color-brand2-20',
                                backgroundColorDark: '$color-brand2-transparent-56',
                            },
                            disabled: {
                                textColor: '$color-brand2-20',
                                iconTintColor: '$color-brand2-20',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    secondary: {
                        textColor: '$color-brand1-500',
                        iconTintColor: '$color-brand1-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-brand1-500',
                                iconTintColor: '$color-brand1-500',
                                backgroundColor: '$color-brand1-5',
                                backgroundColorDark: '$color-brand1-transparent-40',
                            },
                            active: {
                                textColor: '$color-brand1-500',
                                iconTintColor: '$color-brand1-500',
                                backgroundColor: '$color-brand1-20',
                                backgroundColorDark: '$color-brand1-transparent-56',
                            },
                            focus: {
                                textColor: '$color-brand1-500',
                                iconTintColor: '$color-brand1-500',
                                backgroundColor: '$color-brand1-20',
                                backgroundColorDark: '$color-brand1-transparent-56',
                            },
                            disabled: {
                                textColor: '$color-brand1-20',
                                iconTintColor: '$color-brand1-20',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    tertiary: {
                        textColor: '$color-text-primary',
                        iconTintColor: '$color-text-primary',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-text-primary',
                                iconTintColor: '$color-text-primary',
                                backgroundColor: '$color-gray-50',
                                backgroundColorDark: '$color-gray-transparent-40',
                            },
                            active: {
                                textColor: '$color-text-primary',
                                iconTintColor: '$color-text-primary',
                                backgroundColor: '$color-gray-100',
                                backgroundColorDark: '$color-gray-transparent-56',
                            },
                            focus: {
                                textColor: '$color-text-primary',
                                iconTintColor: '$color-text-primary',
                                backgroundColor: '$color-gray-100',
                                backgroundColorDark: '$color-gray-transparent-56',
                            },
                            disabled: {
                                textColor: '$color-text-extra-subtle',
                                iconTintColor: '$color-text-extra-subtle',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    success: {
                        textColor: '$color-success-500',
                        iconTintColor: '$color-success-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-success-500',
                                iconTintColor: '$color-success-500',
                                backgroundColor: '$color-success-5',
                                backgroundColorDark: '$color-success-transparent-40',
                            },
                            active: {
                                textColor: '$color-success-500',
                                iconTintColor: '$color-success-500',
                                backgroundColor: '$color-success-20',
                                backgroundColorDark: '$color-success-transparent-56',
                            },
                            focus: {
                                textColor: '$color-success-500',
                                iconTintColor: '$color-success-500',
                                backgroundColor: '$color-success-20',
                                backgroundColorDark: '$color-success-transparent-56',
                            },
                            disabled: {
                                textColor: '$color-success-20',
                                iconTintColor: '$color-success-20',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    info: {
                        textColor: '$color-info-500',
                        iconTintColor: '$color-info-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-info-500',
                                iconTintColor: '$color-info-500',
                                backgroundColor: '$color-info-5',
                                backgroundColorDark: '$color-info-transparent-40',
                            },
                            active: {
                                textColor: '$color-info-500',
                                iconTintColor: '$color-info-500',
                                backgroundColor: '$color-info-20',
                                backgroundColorDark: '$color-info-transparent-56',
                            },
                            focus: {
                                textColor: '$color-info-500',
                                iconTintColor: '$color-info-500',
                                backgroundColor: '$color-info-20',
                                backgroundColorDark: '$color-info-transparent-56',
                            },
                            disabled: {
                                textColor: '$color-info-20',
                                iconTintColor: '$color-info-20',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    warning: {
                        textColor: '$color-warning-500',
                        iconTintColor: '$color-warning-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-warning-500',
                                iconTintColor: '$color-warning-500',
                                backgroundColor: '$color-warning-5',
                                backgroundColorDark: '$color-warning-transparent-40',
                            },
                            active: {
                                textColor: '$color-warning-500',
                                iconTintColor: '$color-warning-500',
                                backgroundColor: '$color-warning-20',
                                backgroundColorDark: '$color-warning-transparent-56',
                            },
                            focus: {
                                textColor: '$color-warning-500',
                                iconTintColor: '$color-warning-500',
                                backgroundColor: '$color-warning-20',
                                backgroundColorDark: '$color-warning-transparent-56',
                            },
                            disabled: {
                                textColor: '$color-warning-20',
                                iconTintColor: '$color-warning-20',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    danger: {
                        textColor: '$color-danger-500',
                        iconTintColor: '$color-danger-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-danger-500',
                                iconTintColor: '$color-danger-500',
                                backgroundColor: '$color-danger-5',
                                backgroundColorDark: '$color-danger-transparent-40',
                            },
                            active: {
                                textColor: '$color-danger-500',
                                iconTintColor: '$color-danger-500',
                                backgroundColor: '$color-danger-20',
                                backgroundColorDark: '$color-danger-transparent-56',
                            },
                            focus: {
                                textColor: '$color-danger-500',
                                iconTintColor: '$color-danger-500',
                                backgroundColor: '$color-danger-20',
                                backgroundColorDark: '$color-danger-transparent-56',
                            },
                            disabled: {
                                textColor: '$color-danger-20',
                                iconTintColor: '$color-danger-20',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    gray: {
                        textColor: '$color-gray-200',
                        iconTintColor: '$color-gray-200',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-gray-200',
                                iconTintColor: '$color-gray-200',
                                backgroundColor: '$color-gray-10',
                                backgroundColorDark: '$color-gray-transparent-40',
                            },
                            active: {
                                textColor: '$color-gray-200',
                                iconTintColor: '$color-gray-200',
                                backgroundColor: '$color-gray-80',
                                backgroundColorDark: '$color-gray-transparent-56',
                            },
                            focus: {
                                textColor: '$color-gray-200',
                                iconTintColor: '$color-gray-200',
                                backgroundColor: '$color-gray-80',
                                backgroundColorDark: '$color-gray-transparent-56',
                            },
                            disabled: {
                                textColor: '$color-gray-80',
                                iconTintColor: '$color-gray-80',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    dark: {
                        textColor: '$color-text-white',
                        iconTintColor: '$color-text-white',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-text-white',
                                iconTintColor: '$color-text-white',
                                backgroundColor: '$color-gray-500',
                                backgroundColorDark: '$color-gray-transparent-40',
                            },
                            active: {
                                textColor: '$color-text-white',
                                iconTintColor: '$color-text-white',
                                backgroundColor: '$color-brand2-500',
                                backgroundColorDark: '$color-gray-transparent-56',
                            },
                            focus: {
                                textColor: '$color-text-white',
                                iconTintColor: '$color-text-white',
                                backgroundColor: '$color-brand2-500',
                                backgroundColorDark: '$color-gray-transparent-56',
                            },
                            disabled: {
                                textColor: '$color-gray-500',
                                iconTintColor: '$color-gray-500',
                                backgroundColor: '$color-gray-800',
                                backgroundColorDark: '$color-gray-800',
                            },
                        },
                    },
                },
            },
        },
        ghostLink: {
            mapping: {},
            variantGroups: {
                status: {
                    primary: {
                        textColor: '$color-brand2-500',
                        iconTintColor: '$color-brand2-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-brand2-200',
                                iconTintColor: '$color-brand2-200',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            active: {
                                textColor: '$color-brand2-900',
                                iconTintColor: '$color-brand2-900',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            focus: {
                                textColor: '$color-brand2-900',
                                iconTintColor: '$color-brand2-900',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            disabled: {
                                textColor: '$color-brand2-20',
                                iconTintColor: '$color-brand2-20',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    secondary: {
                        textColor: '$color-brand1-500',
                        iconTintColor: '$color-brand1-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-brand1-200',
                                iconTintColor: '$color-brand1-200',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            active: {
                                textColor: '$color-brand1-900',
                                iconTintColor: '$color-brand1-900',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            focus: {
                                textColor: '$color-brand1-900',
                                iconTintColor: '$color-brand1-900',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            disabled: {
                                textColor: '$color-brand1-20',
                                iconTintColor: '$color-brand1-20',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    tertiary: {
                        textColor: '$color-text-primary',
                        iconTintColor: '$color-text-primary',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-gray-300',
                                iconTintColor: '$color-gray-300',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            active: {
                                textColor: '$color-gray-500',
                                iconTintColor: '$color-gray-500',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            focus: {
                                textColor: '$color-gray-500',
                                iconTintColor: '$color-gray-500',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            disabled: {
                                textColor: '$color-text-extra-subtle',
                                iconTintColor: '$color-text-extra-subtle',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    success: {
                        textColor: '$color-success-500',
                        iconTintColor: '$color-success-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-success-200',
                                iconTintColor: '$color-success-200',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            active: {
                                textColor: '$color-success-900',
                                iconTintColor: '$color-success-900',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            focus: {
                                textColor: '$color-success-900',
                                iconTintColor: '$color-success-900',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            disabled: {
                                textColor: '$color-success-20',
                                iconTintColor: '$color-success-20',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    info: {
                        textColor: '$color-info-500',
                        iconTintColor: '$color-info-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-info-200',
                                iconTintColor: '$color-info-200',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            active: {
                                textColor: '$color-info-900',
                                iconTintColor: '$color-info-900',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            focus: {
                                textColor: '$color-info-900',
                                iconTintColor: '$color-info-900',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            disabled: {
                                textColor: '$color-info-20',
                                iconTintColor: '$color-info-20',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    warning: {
                        textColor: '$color-warning-500',
                        iconTintColor: '$color-warning-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-warning-200',
                                iconTintColor: '$color-warning-200',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            active: {
                                textColor: '$color-warning-900',
                                iconTintColor: '$color-warning-900',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            focus: {
                                textColor: '$color-warning-900',
                                iconTintColor: '$color-warning-900',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            disabled: {
                                textColor: '$color-warning-20',
                                iconTintColor: '$color-warning-20',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    danger: {
                        textColor: '$color-danger-500',
                        iconTintColor: '$color-danger-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-danger-200',
                                iconTintColor: '$color-danger-200',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            active: {
                                textColor: '$color-danger-900',
                                iconTintColor: '$color-danger-900',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            focus: {
                                textColor: '$color-danger-900',
                                iconTintColor: '$color-danger-900',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            disabled: {
                                textColor: '$color-danger-20',
                                iconTintColor: '$color-danger-20',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    gray: {
                        textColor: '$color-gray-200',
                        iconTintColor: '$color-gray-200',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-gray-100',
                                iconTintColor: '$color-gray-100',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            active: {
                                textColor: '$color-gray-300',
                                iconTintColor: '$color-gray-300',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            focus: {
                                textColor: '$color-gray-300',
                                iconTintColor: '$color-gray-300',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            disabled: {
                                textColor: '$color-gray-80',
                                iconTintColor: '$color-gray-80',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    dark: {
                        textColor: '$color-text-white',
                        iconTintColor: '$color-text-white',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                textColor: '$color-gray-200',
                                iconTintColor: '$color-gray-200',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            active: {
                                textColor: '$color-gray-400',
                                iconTintColor: '$color-gray-400',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            focus: {
                                textColor: '$color-gray-400',
                                iconTintColor: '$color-gray-400',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                            disabled: {
                                textColor: '$color-gray-600',
                                iconTintColor: '$color-gray-600',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                },
            },
        },
    },
};
export default {
    tokens,
    theme,
};
//# sourceMappingURL=DNAButton.theme.alucio.js.map